module.exports = __webpack_public_path__ + "static/media/icomoon.5dc0eef7.eot";